/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ListGroupCompanies200ResponseCompaniesInner } from './ListGroupCompanies200ResponseCompaniesInner';
import {
    ListGroupCompanies200ResponseCompaniesInnerFromJSON,
    ListGroupCompanies200ResponseCompaniesInnerFromJSONTyped,
    ListGroupCompanies200ResponseCompaniesInnerToJSON,
    ListGroupCompanies200ResponseCompaniesInnerToJSONTyped,
} from './ListGroupCompanies200ResponseCompaniesInner';

/**
 * PG連携会社一覧レスポンス
 * @export
 * @interface ListGroupCompanies200Response
 */
export interface ListGroupCompanies200Response {
    /**
     * 
     * @type {Array<ListGroupCompanies200ResponseCompaniesInner>}
     * @memberof ListGroupCompanies200Response
     */
    companies?: Array<ListGroupCompanies200ResponseCompaniesInner>;
}

/**
 * Check if a given object implements the ListGroupCompanies200Response interface.
 */
export function instanceOfListGroupCompanies200Response(value: object): value is ListGroupCompanies200Response {
    return true;
}

export function ListGroupCompanies200ResponseFromJSON(json: any): ListGroupCompanies200Response {
    return ListGroupCompanies200ResponseFromJSONTyped(json, false);
}

export function ListGroupCompanies200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListGroupCompanies200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'companies': json['companies'] == null ? undefined : ((json['companies'] as Array<any>).map(ListGroupCompanies200ResponseCompaniesInnerFromJSON)),
    };
}

export function ListGroupCompanies200ResponseToJSON(json: any): ListGroupCompanies200Response {
    return ListGroupCompanies200ResponseToJSONTyped(json, false);
}

export function ListGroupCompanies200ResponseToJSONTyped(value?: ListGroupCompanies200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companies': value['companies'] == null ? undefined : ((value['companies'] as Array<any>).map(ListGroupCompanies200ResponseCompaniesInnerToJSON)),
    };
}

